import { Heading } from '@/components/base/heading'
import { Table } from '@/components/equipment/table'

export const Index = () => {
  return (<div className="flex flex-col gap-3">
    <Heading level={ 1 } size="3xl">Equipment</Heading>
    <Table />
  </div>)
}
